import useAuth from "../../modules/auth/hooks";
import React, {  useCallback, useEffect, useState } from "react";
import {
  Card,
  CardHeader,
  ListGroup,
  ListGroupItem,
  Row,
  Col,
  FormInput,
  // Button,
  FormSelect,
  Button
} from "shards-react";

const UserId = React.memo(({userid, onChange}) => {
  
  return(
    <Row form>
      {/* First Name */}
      <Col md="12" className="form-group">
        <label htmlFor="feFirstName">아이디</label>
        <FormInput
          id="feFirstName"
          placeholder="ID"
          name="userid"
          value={userid}
          onChange={onChange}
        />
      </Col>
    </Row>
  )
})

const UserAccountDetails = () => {
  const [inputs, setInputs] = useState({
    userid: "",
    username: '',
    password: "",
    email: "",
    level: "",
  })
  
  const onChange = useCallback((e) => {
    const {value, name} = e.target;
    setInputs({
      ...inputs,
      [name] : value
    })
  },[inputs]);

  const {userid, username, password, email, level } = inputs;
  const [currentOrNew, setCurrentOrNew] = useState(false)

  const { auth, 
    register, 
    // login
   } = useAuth();

  const formatCheck = () => {
    if(!userid) return false;
    if(!username) return false;
  }
  
  const onSubmit = useCallback(e => {
    e.preventDefault();
    const isRegister = window.confirm("새 관리자를 만드시겠습니까?")
    isRegister && register({
      userid,
      username,
      email,
      password,
      level
    });
  },[inputs]);

  // const onLogin = e => {
  //   e.preventDefault();
  //   login({
  //     userid,
  //     password
  //   });
  // };
  
  useEffect(
    () => {
      if (auth.userid) return;
      if (username) return;
      if(!email){
        const { user } = auth;
      setInputs(user);
      }
    },
    []
  );
  const onToggle = useCallback(() => {
    if (!currentOrNew){
      setInputs({
        userid: "",
        username: "",
        email: "",
        password: "",
        level: 1
      })
    } else{
      const { user } = auth;
      setInputs(user)
    }
  },[inputs]);
  const {user} = auth
  
  return (
    <Card small className="mb-4" style={{height: "100%"}}>
      <CardHeader className="border-bottom">
        <div style={{
          display:'flex',
          justifyContent:'space-between',
          alignItems:'baseline',
          height:20
        }}>
          <h6 className="m-0">{currentOrNew? "관리자 생성": "현재 관리자"}</h6>
          {user.level ==='3' && <div style={{
            // position: 'absolute',
            // right: 0,
            // top:0,
            // margin: 15,
            cursor:"pointer",
            display:"flex"
          }}
          onClick={()=>{
            setCurrentOrNew(prev => !prev) 
            onToggle()
          }}
          >
            <p>{currentOrNew? '현재 관리자 보기' : '새 관리자 만들기'}</p>
            <i className="material-icons" style={{
                fontSize: '25px',
                
                marginTop: '-3px'
                }}>refresh</i>
          </div>}
        </div>
      </CardHeader>
      <ListGroup flush>
        <ListGroupItem className="p-3">
          <Row>
            <Col>
              {/* <Container> */}
              <UserId userid={userid} onChange={onChange}/>
              <Row form>
                {/* First Name */}
                <Col md="12" className="form-group">
                  <label htmlFor="feFirstName">닉네임</label>
                  <FormInput
                    id="feFirstName"
                    placeholder="Nickname"
                    name="username"
                    value={username}
                    onChange={onChange}
                  />
                </Col>
              </Row>
              <Row form>
                {/* Email */}
                <Col md="12" className="form-group">
                  <label htmlFor="feEmail">이메일</label>
                  <FormInput
                    type="email"
                    id="feEmail"
                    placeholder="Email Address"
                    name="email"
                    value={email}
                    onChange={onChange}
                    autoComplete="email"
                  />
                </Col>
                {/* Password */}
              </Row>
              <Row form>
                <Col md="12" className="form-group">
                  <label htmlFor="fePassword">비밀번호</label>
                  <FormInput
                    type="password"
                    id="fePassword"
                    placeholder="Password"
                    name="password"
                    value={password}
                    onChange={onChange}
                    autoComplete="current-password"
                  />
                </Col>
              </Row>
              <Row form>
                {/* City */}
                <Col md="12" className="form-group">
                  <label htmlFor="feCity">권한등급</label>
                  <FormSelect disabled={!currentOrNew ? true : false} value={level} onChange={onChange} name="level">
                    <option>1</option>
                    <option>2</option>
                    <option>3</option>
                  </FormSelect>
                </Col>
              </Row>
              <div className="w-100" style={{position:'relative', marginBottom:20}}>
              {currentOrNew && <Button onClick={onSubmit} theme="accent" className="ml-auto" style={{position:"absolute", right:0}}>
                  제출
                </Button>}
              </div>
              {/* <Button onClick={onLogin} theme="accent" style={{marginLeft: "calc(100% - 64px)"}}>
                Login
              </Button> */}
              {/* </Container> */}
            </Col>
          </Row>
        </ListGroupItem>
      </ListGroup>
    </Card>
  );
};

export default React.memo(UserAccountDetails);
